import { config, handleResponse } from '../../_helpers';

export const collectionServices = {
    // GET
    getWaybillRefforCollection,
    waybillforCollectionOtherCharges,
    loadAllCreatedCollection,
    getCollectionId,
    getCollectionIdOtherCharge,

    // POST
    createCollection,

    // PUT
    updateCollection,

    // DELETE
    deleteCollection,

    // OTHER
    calculateCwt,
    excessPaymentSetting,
    otherIncomeAccounts,
    generateReceiptNo,
}

function generateReceiptNo(search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/generateReceiptNo`, requestOptions).then(handleResponse);
}

function otherIncomeAccounts(search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/otherIncomeAccounts`, requestOptions).then(handleResponse);
}

function excessPaymentSetting(search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/excessPaymentSetting`, requestOptions).then(handleResponse);
}

function getWaybillRefforCollection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Collections/getWaybillRefforCollection/${waybillRef}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Collections/waybillforCollection`, requestOptions).then(handleResponse);
}

function waybillforCollectionOtherCharges(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/waybillforCollectionOtherCharges`, requestOptions).then(handleResponse);
}

function loadAllCreatedCollection(payload) {
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if(search){
    //     return fetch(`${config.apiUrl}/Collections/loadAllCreatedCollection?userId=${userId}&isViewer=${IsViewer}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/Collections/loadAllCreatedCollection?userId=${userId}&isViewer=${IsViewer}`, requestOptions).then(handleResponse);
    // }
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/loadCollection`, requestOptions).then(handleResponse);
}

function getCollectionId(payload) {
    // const requestOptions = {
    //     method: 'GET'
    // };
    // return fetch(`${config.apiUrl}/Collections/getCollectionId/${collectioId}`, requestOptions).then(handleResponse);
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Collections/readCollection`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Collections/readCollection1`, requestOptions).then(handleResponse);
}

function getCollectionIdOtherCharge(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/readCollectionOtherCharges`, requestOptions).then(handleResponse);
}

function createCollection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Collections/createCollection`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Collections/collectionToBase`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Collections/collectionToBase1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Collections/collectionToBaseV2`, requestOptions).then(handleResponse);
}

function updateCollection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/updateCollection`, requestOptions).then(handleResponse);
}

function deleteCollection(selected) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(selected),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/delete`, requestOptions).then(handleResponse);
}
function calculateCwt(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Collections/calculateCwt`, requestOptions).then(handleResponse);
}